var _path, _rect, _rect2, _rect3, _path2, _rect4, _rect5, _path3, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 22H36V72C36 76.42 32.42 80 28 80H26C21.58 80 18 76.42 18 72V22Z",
    fill: "none",
    stroke: "#C75E5A",
    strokeWidth: 2.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 62,
    width: 15,
    height: 12,
    fill: "#F9907B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 50,
    width: 15,
    height: 12,
    fill: "#C75E5A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 38,
    width: 15,
    height: 12,
    fill: "#FAC1B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 22H60V72C60 76.42 56.42 80 52 80H50C45.58 80 42 76.42 42 72V22Z",
    fill: "none",
    stroke: "#C75E5A",
    strokeWidth: 2.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 43.5,
    y: 62,
    width: 15,
    height: 12,
    fill: "#FAC1B5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 43.5,
    y: 50,
    width: 15,
    height: 12,
    fill: "#F9907B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66 22H84V72C84 76.42 80.42 80 76 80H74C69.58 80 66 76.42 66 72V22Z",
    fill: "none",
    stroke: "#FAC1B5",
    strokeWidth: 2.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 67.5,
    y: 62,
    width: 15,
    height: 12,
    fill: "#C75E5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterSort);
export default __webpack_public_path__ + "static/media/WaterSort.65a692b8bd6fe0ac884ee442c317d547.svg";
export { ForwardRef as ReactComponent };